import { IconProps } from './types'

export const PlusIcon = ({ className, width = 19, height = 19, viewBox = '0 0 15 15' }: IconProps) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" aria-hidden="true">
    <path d="M7 0V14M0 7H14" stroke="currentColor" />
  </svg>
)
